const keyFor = (liveId: number) => `liveEvent:listenerFullName:${liveId}`;

export function getStoredListenerName(liveId: number | null | undefined): string {
	if (liveId == null || typeof localStorage === "undefined") {
		return "";
	}
	try {
		return (localStorage.getItem(keyFor(liveId)) ?? "").trim();
	} catch {
		return "";
	}
}

export function setStoredListenerName(liveId: number | null | undefined, fullName: string): void {
	if (liveId == null || typeof localStorage === "undefined") {
		return;
	}
	try {
		const t = fullName.trim();
		if (t) {
			localStorage.setItem(keyFor(liveId), t);
		} else {
			localStorage.removeItem(keyFor(liveId));
		}
	} catch {
		/* private mode, quota, etc. */
	}
}
